function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from 'react';
import FormBuilder from '../FormBuilder';
import PropTypes from 'prop-types';

var ExpandIfX = function (_Component) {
  _inherits(ExpandIfX, _Component);

  function ExpandIfX() {
    var _temp, _this, _ret;

    _classCallCheck(this, ExpandIfX);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.componentWillMount = function () {
      // Set up a function that will clear any expansion contents if
      // our expansion is closed
      var form = _this.context.form;
      var name = _this.props.name;

      var updater = function updater(key, value) {
        var show = _this.show(key, value);
        if (!show) {
          _this.clearContents(_this.props, name);
        }
        form.set(name + '::expanded', show ? 'yes' : '');
      };

      // Run it immediately and also have it listen to the name
      updater();
      for (var _iterator = _this.watchForUpdates(), _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
        var _ref;

        if (_isArray) {
          if (_i >= _iterator.length) break;
          _ref = _iterator[_i++];
        } else {
          _i = _iterator.next();
          if (_i.done) break;
          _ref = _i.value;
        }

        var watched = _ref;

        _this.context.form.setListener(watched, name, updater);
      }
    }, _this.clearContents = function (field, skip) {
      var form = _this.context.form;

      // If this field expands, clear the expansions recursively
      (field.expansion || []).map(function (row) {
        return row.map(_this.clearContents);
      });

      // Make sure we're clearing a valid entry
      if (!field || !field.name || form.get(field.name) === '') return;

      // If this isn't a field to skip, set it to nothing
      if (field.name !== skip) {
        form.set(field.name, '');
      }
    }, _this.watchForUpdates = function () {
      return [_this.props.name];
    }, _this.show = function (key, value) {
      if (key === undefined || value === undefined) {
        value = _this.context.form.get(_this.props.name);
      }
      return value === _this.props.expandIf;
    }, _this.render = function () {
      return _this.show() && React.createElement(FormBuilder, {
        form: _this.props.expansion,
        store: _this.context.form
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  return ExpandIfX;
}(Component);

ExpandIfX.contextTypes = {
  form: PropTypes.object.isRequired
};

ExpandIfX.propTypes = process.env.NODE_ENV !== "production" ? {
  expandIf: PropTypes.string.isRequired,
  expansion: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.object)).isRequired,
  name: PropTypes.string.isRequired
} : {};

export default ExpandIfX;


//////////////////
// WEBPACK FOOTER
// ./node_modules/bodyspec-form-builder/es/Fields/ExpandIfX.js
// module id = 150
// module chunks = 0